@if (unconfirmedTicket) {
  <div>
    <div class="row justify-content-start">
      <div class="col-6">
        <patron-form [formGroup]="formRevisionTicket">
          <div class="card">
            <div class="card-header">Adicionar Commit</div>
            <div class="card-body">
              <div class="form-group">
                <patron-form-field
                  type="text"
                  [formGroup]="formRevisionTicket"
                  formControlName="idCommit"
                  placeholder="ID Commit"
                  label="ID Commit"
                  maxlength="100">
                </patron-form-field>
              </div>
              <div class="row">
                <div class="col">
                  <patron-form-field
                    type="date"
                    [formGroup]="formRevisionTicket"
                    formControlName="dateStringTicket"
                    placeholder="Data"
                    label="Data">
                  </patron-form-field>
                </div>
                <div class="col">
                  <patron-form-field
                    type="text"
                    [formGroup]="formRevisionTicket"
                    formControlName="version"
                    placeholder="Versão"
                    label="Versão"
                    maxlength="10">
                  </patron-form-field>
                </div>
              </div>
              <div class="form-group mt-3">
                <patron-textarea
                  [formGroup]="formRevisionTicket"
                  formControlName="observationTicket"
                  label="Observações"></patron-textarea>
              </div>
              <div class="row justify-content-end">
                <div class="col-auto pr-0">
                  <patron-button
                    iconName="bi bi-x"
                    color="secondary"
                    class="ml-2"
                    [disabled]="loading || editIndex == -1"
                    (click)="cancelEdit()">
                    Cancelar
                  </patron-button>
                </div>
                <div class="col-auto">
                  @if (isDevCanWrite()) {
                    <patron-button color="success" class="ml-2" (click)="saveRevision()">
                      @if (loading) {
                        <i class="pi pi-spin pi-spinner"></i>
                      }
                      @if (!loading) {
                        <i class="pi pi-save"></i>
                      }
                      Salvar
                    </patron-button>
                  }
                </div>
              </div>
            </div>
          </div>
        </patron-form>
      </div>
    </div>
    @if (loading) {
      <div class="row mx-0">
        <div class="col text-muted text-center mt-2">
          <i class="fa fa-spin fa-spinner fa-5x"></i><br />
        </div>
      </div>
    }
    @if (!loading && (!revisions || !revisions.length)) {
      <div class="text-center border py-3">Nenhum ID Commit adicionado</div>
    }
    @if (!loading && revisions) {
      <div>
        @for (revision of revisions; track revision; let i = $index) {
          <div class="row mx-0 py-3 border" [class.bg-light]="i % 2 != 0">
            <div class="col"><b>ID Commit: </b> {{ revision.id_commit }}</div>
            <div class="col"><b>Data: </b> {{ revision.date | date: 'dd/MM/yyyy' }}</div>
            <div class="col"><b>Versão: </b> {{ revision.version }}</div>
            <div class="col"><b>Usuário: </b> {{ revision.user?.name }}</div>
            <div class="col-auto pr-0">
              <patron-button
                iconName="pi pi-file-edit"
                class="ml-2"
                (click)="edit(i)"
                [disabled]="editIndex > -1 || deleteIndex > -1">
              </patron-button>
            </div>
            <div class="col-auto pl-2">
              <patron-button
                iconName="pi pi-trash"
                color="danger"
                class="ml-2"
                (click)="openDeleteConfirmationModal(i)"
                [disabled]="editIndex > -1 || deleteIndex > -1">
              </patron-button>
            </div>
            <div class="col-12"><b>Observação: </b> {{ revision.observation }}</div>
          </div>
        }
      </div>
    }
    <patron-modal
      title="Remover requisito"
      cancelButtonText="Cancelar"
      confirmButtonText="Deletar"
      [visible]="visibleModalDelete"
      (confirm)="delete()"
      (cancel)="cancelModal()">
      {{ deleteMessageModal }}
    </patron-modal>
  </div>
}
